// extracted by mini-css-extract-plugin
export default {"cardContainer":"cards_cardContainer__YDDH9"};